import React from 'react';
const CTAButton = () => {
  return <a href="https://openflowdesigns.com/products/skin-safe-nasal-strips-nasal-dilator-intake-breathing-nasal-strip-starter-kit-boost-oxygen-reduce-snoring-magnetic-nose-strips" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#8b5a00] hover:bg-[#6d4600] text-white font-bold py-3 px-8 rounded-lg text-xl shadow-lg transform transition hover:scale-105" data-id="element-125">
      Get Your Open Flow Design Strips Today
    </a>;
};
export default CTAButton;